export const specialMenuListDataSelector = state => state.special_menu.listData;

export const specialMenuStepSelector = state => state.special_menu.formStep;
export const specialMenuCompletedStepsSelector = state => state.special_menu.completedSteps;

export const createOrUpdateErrorsSelector = state => state.special_menu.errors;
export const deleteInProcessSelector = state => state.special_menu.deleteInProcess;
export const createOrUpdateInProcessSelector = state => state.special_menu.createOrUpdateInProcess;
export const currentItemSelector = state => state.special_menu.currentItem;
export const currentItemLoadingSelector = state => state.special_menu.itemLoading;

